let selectedSubproduct;
const $ = require('jquery');
const {updateFormSummary, updateFormStructure} = require("../service-form/service-form");
const {trackViewItem} = require('./../../ecommerceGTag');

$(document).ready(function () {
    if($('.single-service-page').length === 0) {
        return;
    }

    const { selectSubproduct, switchSubproduct } = require('./subproducts-selection');

    $('.subproduct').on('click', function () {
        selectSubproduct($(this));
    });

    $('#nextSubproduct').on('click', function () {
        switchSubproduct('next');
        scrollToDescription();
    });

    $('#prevSubproduct').on('click', function () {
        switchSubproduct('prev');
        scrollToDescription();
    });
});

function getListOfSubproducts(privacyType) {
    if (privacyType === 'Private') {
        return $('#servicePrivateSection').find('.subproduct').not('.d-none');
    }

    return $('#serviceSharedSection').find('.subproduct').not('.d-none');
}

function showSubproduct(service_id, privacy_type) {
    const subproductDescription = $('#subproductDescription');
    const reversePrivacy = privacy_type==="Private" ? "shared" : "private";
    subproductDescription.html('');
    const subproduct = currentSubproducts.find(function (subproduct) {
        selectedSubproduct = subproduct;
        return subproduct.service_id == service_id;
    });
    $('.subproduct').removeClass('selected');
    $('.subproduct[data-service-id="' + service_id + '"][data-privacy-type="'+ privacy_type +'"]').addClass('selected');
    $('.subproduct-description').parent().removeClass('d-none');
    if(typeof subproduct === 'undefined') {
        subproductDescription.html(`<i class="fa fa-minus-square excludedIcon" aria-hidden="true"></i> Unfortunately, we have no availability for this type of tour. Please consider checking our <strong>${reversePrivacy} tours</strong> instead`);
    } else {
        const features = privacy_type === 'Group' ? subproduct.in_ex_features_shared : subproduct.in_ex_features_private;
        subproductDescription.append(prepareIncludedExcludedFeatures(features));
    }
    subproductDescription.addClass('animate').on('animationend', function () {
        $(this).removeClass('animate');
    });
}

function selectSubproduct(subproduct) {
    $('#serviceOrderForm input#subservice_id').val(subproduct.data('service-id')).change();
    $('#serviceOrderForm input#availability_service_id').val(subproduct.data('av-service-id')).change();
    showSubproduct(subproduct.data('service-id'), subproduct.data('privacy-type'));
    updateFormStructure(getSelectedSubproduct());
    updateFormSummary(subproduct.find('.subproduct-price').text());
    if(!subproduct.length===0)
        trackViewItem(subproduct.data('service-id'));
}

function switchSubproduct(direction) {
    let subproducts = getListOfSubproducts($('#private_or_group').val()).not('.d-none');
    let selectedSubproduct = subproducts.filter('.selected');
    let availableSubproducts = subproducts.not('.unavailable');
    if (availableSubproducts.length < 2) {
        return;
    }

    let nextSubproduct, prevSubproduct;

    if (direction === 'next') {
        nextSubproduct = subproducts.eq((subproducts.index(selectedSubproduct) + 1) % subproducts.length);
        while(nextSubproduct.hasClass('unavailable d-none')){
            nextSubproduct = subproducts.eq((subproducts.index(nextSubproduct) + 1) % subproducts.length);
        }
        selectSubproduct(nextSubproduct);
    } else if (direction === 'prev') {
        prevSubproduct = subproducts.eq((subproducts.index(selectedSubproduct) - 1 + subproducts.length) % subproducts.length);
        while(prevSubproduct.hasClass('unavailable d-none')){
            prevSubproduct = subproducts.eq((subproducts.index(prevSubproduct) - 1 + subproducts.length) % subproducts.length);
        }
        selectSubproduct(prevSubproduct);
    }

    $('#counterSubproduct').text(subproducts.index($('.subproduct.selected')) + 1 + '/' + subproducts.length);
}


function setDefaultSubproduct(privacyType = false) {
    if(!privacyType) {
        privacyType = $('#private_or_group').val();
    }
    var subproducts = getListOfSubproducts(privacyType);
    selectSubproduct(subproducts.not('.unavailable').first());
    $('#counterSubproduct').text('1/' + subproducts.length);
}

function prepareIncludedExcludedFeatures(features) {
    let result = '';
    $.each(features, function (key, value) {
        result += '<div class="row"><div class="col-12 mb-2">';
        if (value.type === 'INCL') {
            result += '<i class="fa fa-plus-square includedIcon" aria-hidden="true"></i>';
        }
        if (value.type === 'EXCL') {
            result += '<i class="fa fa-minus-square excludedIcon" aria-hidden="true"></i>';
        }
        result += value.text + '</div></div>';
    });
    return result;
}

function getSelectedSubproduct() {
    return selectedSubproduct;
}
function scrollToDescription(){
        $('html, body').animate({
            scrollTop: $('.subproduct-description').offset().top - 230
        }, 1000);
}

module.exports = { selectSubproduct, showSubproduct, switchSubproduct, setDefaultSubproduct, getSelectedSubproduct, getListOfSubproducts };
